<ng-container *ngFor="let detail of details; let i = index">
	<div class="milk-details">
		<div class="milk-details__icon">
			<fa-icon [icon]="detail.icon" [fixedWidth]="true" size="sm"></fa-icon>
		</div>

		<div class="milk-details__label">{{ detail.label }}</div>

		<div>
			<ng-container *ngFor="let value of detail.values">
				<div
					class="milk-details__value"
					[attr.data-testid]="'product_details__value_' + i"
				>
					{{ value || '--' }}
				</div>
			</ng-container>
		</div>
	</div>
</ng-container>
